import {Component, OnDestroy, OnInit} from '@angular/core';

import {CacheDateService} from "./cache_date.service";
import {EventsService} from "app/lib/EventsService";
import { Repeater } from "app/lib/Repeater";
import {parseDate} from "app/lib/lib";

interface ClusterCacheInfo {
	n: number;
	endAt: string;
}

@Component({
	selector: 'cache-date',
	template: `
		<ng-template #popoverBody>
			<ng-container
				*ngFor="let cluster of clusters"
			>
				{{ cluster.n }}: {{ cluster.endAt }}
			</ng-container>
		</ng-template>
		
		<div class="float-right">
			<source-selector></source-selector>
			&nbsp;&nbsp;
			<span
				class="badge badge-{{labelStatus}}"
				triggers="mouseenter:mouseleave"
				[sextant]="'cacheDate'"
				[ngbPopover]="popoverBody"
			>
				<i
					*ngIf="pause"
					class="fa fa-pause-circle"
					aria-hidden="true"
					[title]="'adminstat.support.cache_info.rebuilding paused now' | translate"
				></i>
				
				{{ endAt | dateFormat: 'DD.MM.YYYY HH:mm' }}
			</span>
		</div>
	`
})
export class CacheDateComponent implements OnInit, OnDestroy {
	public repeater: Repeater;
	
	public pause: boolean = false;
	public hasAccess: boolean = false;
	public isRefresh: boolean = false;
	public endAt: string;
	public startAt: string;
	public labelStatus: string = 'secondary';
	public clusters: ClusterCacheInfo[] = [];
	
	public popoverBody: string = '';
	
	constructor(
		public cacheDateService: CacheDateService,
		public eventsService: EventsService,
	) {}
		
	
	async setData() {
		const me = this;

		const {
			pause,
			hasAccess,
			isRefresh,
			endAt,
			startAt,
			clusters,
		} = await me.cacheDateService.get().toPromise();

		me.pause = pause;
		me.hasAccess = hasAccess;
		me.isRefresh = isRefresh;
		me.endAt = endAt;
		me.startAt = startAt;
		me.clusters = clusters;
		
		if (me.pause) {
			me.labelStatus = 'warning';
		} else if (parseDate().diff(parseDate(me.endAt)) > 1000 * 60 * 30) {
			me.labelStatus = 'danger';

			// Если перестроение активно, но было запущено больше 30 минут назад, то отображать danger!
			me.isRefresh = false;
		} else {
			me.labelStatus = 'success';
		}
	}
	
	
	async ngOnInit() {
		const me = this;
		
		await me.setData();
		
		me.repeater = new Repeater(async function () {
			await me.setData();
		}, 30000);

		me.repeater.start();
	}
	
	
	ngOnDestroy() {
		if (this.repeater) {
			this.repeater.stop();
		}
	}
}
